import { Dialog, DialogContent, DialogTitle } from '@codes/ui-kit';

export const ImageViewDialog = ({
    url,
    open,
    setOpen,
}: {
    url: string;
    open: boolean;
    setOpen: (open: boolean) => void;
}) => {
    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogTitle></DialogTitle>
            <DialogContent aria-describedby={undefined}>
                <div
                    className="w-full h-96 !bg-center bg-gray-400 !bg-no-repeat !bg-contain"
                    style={{ background: `url(${url})` }}
                ></div>
            </DialogContent>
        </Dialog>
    );
};
